import { addMinutes as addMinutes$1, addMilliseconds } from 'date-fns';
import { getTimezoneOffset } from 'date-fns-tz';
import { convertZonedDateToSystemDate, getDateTimeConfig, convertSystemDateToZonedDate } from './DateUtils2.js';

const addMinutes = (tzDate, amount) => {
    const systemDate = convertZonedDateToSystemDate(tzDate);
    const newDate = addMinutes$1(systemDate, amount);
    const offset = getTimezoneOffset(getDateTimeConfig().systemTimezone, systemDate);
    const offsetNewDate = getTimezoneOffset(getDateTimeConfig().systemTimezone, newDate);
    const offsetDiff = Math.abs(offsetNewDate - offset);
    return convertSystemDateToZonedDate(addMilliseconds(newDate, offsetDiff));
};

export { addMinutes };
